export default (level, years) => {
    let label = null
    if(level) label = level.name
    if(years) label += `, ${years.name} years`
    return label
}